export const RETRY_COUNT = 1;

export const HTTP_METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
  PATCH: "PATCH",
  HEAD: "HEAD",
  OPTIONS: "OPTIONS",
} as const;

export const OTP_PURPOSE = {
  AUTH_ACTIONS: 1,
  DETAILS_VERIFICATION: 2,
  CREATOR_EMAIL_UPDATION: 3,
  CREATOR_PHONE_NUMBER_UPDATION: 4,
  EUD_EMAIL_LOGIN: 5,
  EUD_PHONE_NUMBER_LOGIN: 6,
};

export const TOKEN_TYPE = {
  CREATOR_TOOL: 1,
  HOST_PAGES: 2,
  CUSTOMER_LOGIN: 3,
  AFFILIATE_PORTAL: 4,
};

export const JWT_GRANT_TYPES = {
  AUTHORIZATION_CODE: "authorization_code",
  REFRESH_TOKEN: "refresh_token",
};
export const JWT_TOKEN_HEADER_KEY = "jwt-token";

export const LOGIN_INPUT_TYPE = {
  EMAIL: 1,
  PHONE: 2,
  GOOGLE: 3,
};

export const DEFAULT_PAGE_SIZE = 50;
export const INITIAL_PAGE = 1;
export const FIVE_MINUTE_STALE_TIME = 60 * 1000 * 5;
export const ONE_SECOND_STALE_TIME = 1000;

export const EXLY_API_ERROR_STATUS_CODES = {
  AUTH_TOKEN_MISSING: { status: 1, http_status: 400 },
  INVALID_AUTH_TOKEN: { status: 2, http_status: 400 },
  ACCESS_TOKEN_MISSING: { status: 3, http_status: 400 },
  INVALID_JWT_TOKEN: { status: 4, http_status: 400 },
  ACCESS_TOKEN_EXPIRED: { status: 5, http_status: 400 },
  UNKNOWN_USER: { status: 6, http_status: 400 },
  REFRESH_TOKEN_EXPIRED: { status: 7, http_status: 400 },
  REFRESH_TOKEN_MISSING: { status: 8, http_status: 400 },
  INVALID_PLATFORM: { status: 9, http_status: 400 },
  INVALID_CREDENTAILS: { status: 10, http_status: 400 },
  PERMISSION_CHANGED: { status: 11, http_status: 400 },
  ACTION_NOT_ALLOWED: { status: 12, http_status: 400 },
  REDIRECT_TO_SIGNUP: { status: 13, http_status: 400 },
  CUSTOM_FILTER_SEGMENT_ALREADY_PRESENT: { status: 14, http_status: 400 },
  SESSION_BLACKLISTED: { status: 15, http_status: 400 },
  ALLOTED_DEVICE_EXCEEDED_STATUS_CODE: { status: 16, http_status: 400 },
};

export const REFRESH_TOKEN_EXPIRED_STATUS_CODE =
  EXLY_API_ERROR_STATUS_CODES.REFRESH_TOKEN_EXPIRED.status;
